import { useState } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";
import ChatJuriLogo from "../assets/chat_juri_logo.png";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await login(email, password);
    } catch (err) {
      toast.error("Credenciais inválidas");
    }
  }

  return (
    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-gray-950">
      {/* Background com gradiente melhorado e efeitos */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 20% 50%, rgba(15, 76, 69, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(15, 76, 69, 0.2) 0%, transparent 50%), linear-gradient(135deg, #0a1614, #0F4C45 60%, #0a1614)",
        }}
      />

      {/* Container principal */}
      <div className="relative z-10 w-full max-w-lg px-6">
        <form
          onSubmit={handleSubmit}
          className="group space-y-8 rounded-2xl border border-gray-800/50 bg-gray-900/80 p-10 shadow-2xl backdrop-blur-xl"
        >
          <div className="flex flex-col items-center space-y-3">
            <img src={ChatJuriLogo} alt="ChatJuri" className="w-56" />
            <div className="text-center">
              <h2 className="text-2xl font-bold text-white">
                Bem-vindo ao ChatJuri
              </h2>
              <p className="mt-1 text-sm text-gray-400">Entre para continuar</p>
            </div>
          </div>

          {/* Campo e-mail */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-300">E-mail</label>
            <div className="flex items-center rounded-lg bg-gray-800/80 px-4 py-3 ring-1 ring-gray-700/50 transition-all duration-300 focus-within:bg-gray-800 focus-within:ring-2 focus-within:ring-[#0F4C45]/50">
              <Mail className="mr-3 h-5 w-5 text-gray-400 transition-colors duration-300" />
              <input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full bg-transparent text-white placeholder-gray-500 outline-none transition-colors"
              />
            </div>
          </div>

          {/* Campo senha */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-300">Senha</label>
            <div className="flex items-center rounded-lg bg-gray-800/80 px-4 py-3 ring-1 ring-gray-700/50 transition-all duration-300 focus-within:bg-gray-800 focus-within:ring-2 focus-within:ring-[#0F4C45]/50">
              <Lock className="duration-300] mr-3 h-5 w-5 text-gray-400 transition-colors" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-transparent text-white placeholder-gray-500 outline-none transition-colors"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="ml-2 text-gray-400 transition-colors hover:text-gray-300 focus:outline-none"
              >
                {showPassword ? (
                  <EyeOff className="h-5 w-5" />
                ) : (
                  <Eye className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>

          {/* Botão de login */}
          <button
            type="submit"
            className="relative w-full overflow-hidden rounded-lg bg-[#0F4C45] py-3.5 font-bold text-white shadow-lg transition-all duration-300 hover:bg-[#0F4C45]/80"
          >
            Entrar
          </button>

          {/* Rodapé */}
          <div className="border-t border-gray-800/50 pt-6">
            <p className="text-center text-xs text-gray-500">
              © {new Date().getFullYear()} ChatJuri – Todos os direitos
              reservados.
            </p>
            <p className="mb-1 text-center text-xs text-gray-500">
              {process.env.APP_VERSION}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}
